module.exports = __webpack_public_path__ + "assets/img/de204e3386b6bdc45060380bcaacff7f.png";